module.exports = __webpack_public_path__ + "static/003_Gippsland-70bdbf755d5305e5b5858d69b1f2e5ba.png";